import React from 'react'
import { inject, observer } from 'mobx-react'
import QuickCreateTooltip from './QuickCreateTooltip'

const QuickCreateOverlay = () => {
  return <QuickCreateTooltip />
}

export default inject('uiStore')(observer(QuickCreateOverlay))
